/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './acceptConvo.defs.js'
export * as $defs from './acceptConvo.defs.js'
